<template>
  <div class="footer-text">
    <span>(주)데이터노우즈 | 대표:김기원 | </span>
    <span>이메일: </span><a href="mailto:support@dataknows.ai" class="footer-link">support@dataknows.ai</a>
    <br>
    <span>사업자등록번호:219-81-31561</span>
    <br>
    <span>서울특별시 강남구 봉은사로 524 인터컨티넨탈 서울 코엑스 스파크플러스</span>
    <br>
    <span>통신판매업신고증: 제 2019-서울서초-1520</span>
    <br>
    <v-dialog
      v-for="(term, index) in terms"
      :key="term.name"
      v-model="term.termDialog"
      style="display:inline"
      fullscreen hide-overlay transition="dialog-bottom-transition"
    >
      <template v-slot:activator="{ on }">
        <div
          v-on="on"
          style="display:inline-block"
        >
          <span class="termLink">{{ term.name }}</span>
          <span v-if="index===0"> · </span>
        </div>
      </template>

      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="term.termDialog=false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <component v-bind:is="term.component"></component>

        <v-card-actions>
          <v-btn color="primary" text @click="term.termDialog=false">확인</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <br>
    <span>Copyright © Dataknows Corp. All rights reserved.</span>
  </div>
</template>

<script>
import Term01Component from '../components/terms/Term01'
import Term02Component from '../components/terms/Term02'

export default {
  data() {
    return {
      terms: [
         {
          termDialog: false,
          name: '이용약관',
        component: Term01Component
        },
        {
          termDialog: false,
          name: '개인정보보호',
          component: Term02Component
        }
      ],
    }
  }

}
</script>

<style scoped>

.termLink {
  color: #FFB300;
  text-decoration: underline;
}

.termLink:hover {
  cursor: pointer;
}

.footer-text {
  margin: 15px auto;
  width: 100%;
  text-align: center;
  font-size: 0.8rem;
}

@media only screen and (max-width: 600px) {
  .footer-text {
    width: 100%;
    margin: 15px 0px;
    font-size: 10px;
  }
}
</style>
